var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAcademicCap(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 31,
    viewBox: "0 0 31 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "academic-cap"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon",
    d: "M15.5 18.0834L27.125 11.6251L15.5 5.16675L3.875 11.6251L15.5 18.0834ZM15.5 18.0834L23.4555 13.6637C24.1564 15.4311 24.5417 17.3581 24.5417 19.375C24.5417 20.2809 24.464 21.1686 24.3148 22.0319C20.9435 22.3597 17.8883 23.7676 15.5 25.9052C13.1117 23.7676 10.0565 22.3597 6.68517 22.0319C6.53605 21.1686 6.45833 20.2808 6.45833 19.3749C6.45833 17.358 6.84357 15.4311 7.54446 13.6637L15.5 18.0834ZM10.3333 25.8333V16.1459L15.5 13.2755",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAcademicCap);
export default __webpack_public_path__ + "static/media/academic-cap.768b451531eff799873674c6adfe2dfe.svg";
export { ForwardRef as ReactComponent };